import { Plate } from '../components/Card';
import React, { useEffect, useState } from 'react';
import {
  getAiRopOverview,
  runAiRopDaily,
  sendAiRopChat,
  approveAiRopAction,
  executeAiRopAction,
} from '../api';

const fmt = (n) => `${Number(n || 0).toLocaleString('ru-RU')} ₽`;

function Card({ title, value, sub, color = '#00a7dc' }) {
  return (
    <div style={{
      background: 'var(--bg2)',
      border: '1px solid var(--border)',
      borderRadius: 14,
      padding: 18,
      minHeight: 110,
    }}>
      <div style={{ color: 'var(--text2)', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{title}</div>
      <div style={{ color, fontSize: 26, fontWeight: 800, marginTop: 8 }}>{value}</div>
      {sub && <div style={{ color: 'var(--text2)', fontSize: 13, marginTop: 6 }}>{sub}</div>}
    </div>
  );
}

function ManagerCard({ item }) {
  return (
    <div style={{
      background: 'var(--bg2)',
      border: '1px solid var(--border)',
      borderRadius: 14,
      padding: 18,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text)' }}>{item.manager_name}</div>
          <div style={{ color: 'var(--text2)', fontSize: 12 }}>
            Bitrix ID: {item.bitrix_user_id || 'не найден'} · TG: {item.telegram_id || 'нет'}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ color: '#0e9f6e', fontWeight: 800 }}>{fmt(item.daily_target)}</div>
          <div style={{ color: 'var(--text2)', fontSize: 12 }}>цель на день</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginTop: 16 }}>
        <div><b>{fmt(item.target_amount)}</b><br /><span style={{ color: 'var(--text2)', fontSize: 12 }}>план</span></div>
        <div><b>{fmt(item.fact_amount)}</b><br /><span style={{ color: 'var(--text2)', fontSize: 12 }}>факт</span></div>
        <div><b>{fmt(item.remaining_amount)}</b><br /><span style={{ color: 'var(--text2)', fontSize: 12 }}>остаток</span></div>
      </div>

      <div style={{ marginTop: 16 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Клиенты</div>
        {(item.customers || []).slice(0, 5).map((c, idx) => (
          <div key={`${c.partner_key || c.name}-${idx}`} style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 4 }}>
            {idx + 1}. {c.name} · {c.orders} заказов · {fmt(c.revenue)}
          </div>
        ))}
      </div>

      <div style={{ marginTop: 14 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Неликвид</div>
        {(item.dead_stock || []).slice(0, 5).map((d, idx) => (
          <div key={`${d.sku}-${idx}`} style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 4 }}>
            {idx + 1}. {d.sku} · {d.name} · {fmt(d.frozen_amount)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function AiRop() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const [chatText, setChatText] = useState('');
  const [chatAnswer, setChatAnswer] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    setError('');
    setLoading(true);
    try {
      setData(await getAiRopOverview());
    } catch (e) {
      setError(e.response?.data?.detail || e.message || 'Ошибка загрузки');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const run = async (dryRun) => {
    setRunning(true);
    setError('');
    try {
      await runAiRopDaily(dryRun);
      await load();
    } catch (e) {
      setError(e.response?.data?.detail || e.message || 'Ошибка запуска');
    } finally {
      setRunning(false);
    }
  };

  const ask = async () => {
    if (!chatText.trim()) return;
    setRunning(true);
    try {
      const res = await sendAiRopChat(chatText);
      setChatAnswer(res.answer || '');
      setChatText('');
      await load();
    } finally {
      setRunning(false);
    }
  };

  const actionCall = async (fn, id) => {
    setRunning(true);
    try {
      await fn(id);
      await load();
    } finally {
      setRunning(false);
    }
  };

  const plan = data?.plan || {};
  const profile = data?.profile || {};
  const progress = plan.target_amount ? Math.min(100, Math.round((plan.fact_amount || 0) / plan.target_amount * 100)) : 0;

  return (
    <div>
      <div className="kp-hero" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 20, flexWrap: 'wrap' }}>
        <div>
          <Plate>Аналитика · отдел продаж</Plate>
          <h1 style={{ margin: 0 }}>AI РОП Академии</h1>
          <p style={{ color: 'var(--text2)', margin: '8px 0 0', fontSize: 13 }}>
            Цель мая 6 млн · Bitrix-first задачи · звонки/мессенджеры фиксируются в Bitrix · Telegram только для эскалаций
          </p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => run(true)} disabled={running} style={btn('var(--border)')}>Dry-run</button>
          <button onClick={() => run(false)} disabled={running} style={btn('#00a7dc')}>Поставить задачи в Bitrix</button>
          <button onClick={load} disabled={loading || running} style={btn('var(--border)')}>Обновить</button>
        </div>
      </div>

      {error && <div style={{ background: '#e04848', color: '#e04848', padding: 12, borderRadius: 10, marginBottom: 16 }}>{error}</div>}
      {loading && <div style={{ color: 'var(--text2)' }}>Загружаю РОПа...</div>}

      {data && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 18 }}>
            <Card title="План месяца" value={fmt(profile.target_amount || plan.target_amount)} sub={profile.period || plan.period} color="#e08a00" />
            <Card title="Факт 1С" value={fmt(plan.fact_amount)} sub={`${progress}% выполнения`} color="#0e9f6e" />
            <Card title="Осталось" value={fmt(plan.remaining_amount)} sub={`${plan.remaining_days || 0} дн. в периоде`} color="#e04848" />
            <Card title="Темп в день" value={fmt(plan.required_daily_amount)} sub="нужно держать" color="#00a7dc" />
          </div>

          <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 14, padding: 14, marginBottom: 20 }}>
            <div style={{ height: 10, background: 'var(--bg3)', borderRadius: 999, overflow: 'hidden' }}>
              <div style={{ width: `${progress}%`, height: '100%', background: '#0e9f6e' }} />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 22 }}>
            {(plan.manager_plans || []).map(item => <ManagerCard key={item.manager_key} item={item} />)}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1.1fr 0.9fr', gap: 16 }}>
            <div style={panel}>
              <h3 style={h3}>Журнал действий</h3>
              {(data.actions || []).length === 0 && <div style={{ color: 'var(--text2)' }}>Действий пока нет.</div>}
              {(data.actions || []).map(a => (
                <div key={a.id} style={{ borderTop: '1px solid var(--border)', padding: '12px 0' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                    <div>
                      <b>{a.title}</b>
                      <div style={{ color: 'var(--text2)', fontSize: 13 }}>{a.manager} · {a.type} · {a.created_at?.slice(0, 16)}</div>
                      {a.external_id && <div style={{ color: '#0e9f6e', fontSize: 13 }}>Bitrix task #{a.external_id}</div>}
                      {a.payload?.error && <div style={{ color: '#e04848', fontSize: 13 }}>{a.payload.error}</div>}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ color: statusColor(a.status), fontWeight: 700 }}>{a.status}</span>
                      {a.status !== 'executed' && (
                        <>
                          <button onClick={() => actionCall(approveAiRopAction, a.id)} disabled={running} style={smallBtn}>OK</button>
                          <button onClick={() => actionCall(executeAiRopAction, a.id)} disabled={running} style={smallBtn}>Run</button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div style={panel}>
              <h3 style={h3}>Чат с РОПом</h3>
              <textarea
                value={chatText}
                onChange={e => setChatText(e.target.value)}
                placeholder="Например: сколько осталось до плана?"
                style={{ width: '100%', minHeight: 90, background: 'var(--bg3)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 10, padding: 10 }}
              />
              <button onClick={ask} disabled={running || !chatText.trim()} style={{ ...btn('#00a7dc'), marginTop: 10 }}>Спросить</button>
              {chatAnswer && <div style={{ marginTop: 14, color: 'var(--text)', lineHeight: 1.5 }}>{chatAnswer}</div>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const btn = (bg) => ({
  background: bg,
  color: '#fff',
  border: 'none',
  borderRadius: 10,
  padding: '10px 14px',
  cursor: 'pointer',
  fontWeight: 700,
});

const smallBtn = {
  background: 'var(--bg3)',
  color: 'var(--text)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '6px 9px',
  cursor: 'pointer',
};

const panel = {
  background: 'var(--bg2)',
  border: '1px solid var(--border)',
  borderRadius: 14,
  padding: 18,
};

const h3 = { margin: '0 0 12px', color: 'var(--text)' };

function statusColor(status) {
  if (status === 'executed') return '#0e9f6e';
  if (status === 'failed') return '#e04848';
  if (status === 'planned') return '#e08a00';
  return 'var(--text2)';
}
